import { motion } from "framer-motion";
import { useData } from "@/context/DataContext";
import { resolveUrl } from "@/lib/api";
import { Reveal } from "@/components/shared/Reveal";

export const Intro = () => {
  const { settings } = useData();
  if (!settings) return null;
  const stats = settings.stats || [];

  return (
    <section data-testid="intro" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          <Reveal>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-8 bg-amber-500" />
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-amber-500">Introduktion</span>
            </div>
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight text-white leading-[1.03]">
              {settings.intro_heading}
            </h2>
            <p className="mt-6 text-base sm:text-lg text-white/65 leading-relaxed whitespace-pre-line">{settings.intro_body}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative group overflow-hidden rounded-2xl border border-white/10">
              <img src={resolveUrl(settings.intro_image)} alt="Novemberkåsan enduro" loading="lazy" className="aspect-ken aspect-[4/5] w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
            </div>
          </Reveal>
        </div>

        {stats.length > 0 && (
          <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px rounded-2xl overflow-hidden border border-white/10 bg-white/10">
            {stats.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: i * 0.1 }}
                className="bg-[#0F1114] px-5 py-8 text-center"
              >
                <div className="font-display text-4xl sm:text-5xl font-black text-amber-500">{s.value}</div>
                <div className="mt-2 font-mono text-[10px] sm:text-xs uppercase tracking-widest text-white/50">{s.label}</div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
